/**
 * W93 Chart-Check Phase 3 — Lese-Seite der persistierten Chart-Ereignisse.
 *
 * Der 18:15-Server-Score-Cron rechnet detectChartEvents über 420 Daily-Bars
 * je Symbol und schreibt das WICHTIGSTE Ereignis + Marken-Zeile nach
 * v5_chart_events. Der Browser liest nur — 420-Bar-Detection für 50+
 * Watchlist-Symbole wäre client-seitig zu teuer.
 *
 * Eine Query für ALLE Symbole; alle Badges teilen sich den TanStack-Cache
 * über denselben queryKey ['chart-events-all'].
 */

import { supabase } from '@/lib/supabase';
import type { ChartEvent, NextMarks } from '@/lib/chart-events';

export interface ChartEventRow {
  symbol: string;
  top_event: ChartEvent | null;
  next_marks: NextMarks | null;
  updated_at: string;
}

export async function fetchChartEventsAll(
  signal?: AbortSignal
): Promise<Map<string, ChartEventRow>> {
  let query = supabase.from('v5_chart_events').select('*');
  if (signal) query = query.abortSignal(signal);
  const { data, error } = await query;
  if (error) throw new Error(`v5_chart_events: ${error.message}`);
  const map = new Map<string, ChartEventRow>();
  for (const row of (data ?? []) as ChartEventRow[]) {
    map.set(row.symbol.toUpperCase(), row);
  }
  return map;
}
